import { useEffect } from 'react'
// Prevent circular dependencies
import { useUpdateNotification } from '../components/ShareMetaSidebar/SubscriptionToggle/operations/useUpdateNotification'

interface UseUnfollowShareFromEmailProps {
  id: string
  versionShortId: string
  userWantsToStopReceivingEmailNotifications: boolean
  subscriptionStatus: 'ON' | 'OFF' | 'PARTIAL'
}

export const useUnfollowShareFromEmail = ({
  id,
  userWantsToStopReceivingEmailNotifications,
  subscriptionStatus,
  versionShortId,
}: UseUnfollowShareFromEmailProps) => {
  const { updateShareNotification } = useUpdateNotification()

  useEffect(
    () => {
      if (
        !userWantsToStopReceivingEmailNotifications ||
        subscriptionStatus === 'OFF'
      ) {
        return
      }

      updateShareNotification({ id, status: 'OFF', versionShortId })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
}
